import { polygonTokens, serializeToken } from '@pancakeswap/tokens'
import { SerializedFarmConfig } from '../types'

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 1, 2) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'CANDY',
    lpAddress: '0x54E53ed24C12c1d3Df7D653587E2f27d3FbaE3d2',
    token: polygonTokens.candy,
    quoteToken: polygonTokens.wmatic,
  },
  {
    pid: 1,
    lpSymbol: 'CANDY-MATIC LP',
    lpAddress: '0xA67FE0Cb496A4a397728DB432fE0E210a5C68BB9',
    boosted: true,
    token: polygonTokens.candy,
    quoteToken: polygonTokens.wmatic,
  },
  {
    pid: 2,
    lpSymbol: 'CANDY-USDT LP',
    lpAddress: '0x75061F73B81652c7940545d7824fe2E74CEB63C8',
    boosted: true,
    token: polygonTokens.candy,
    quoteToken: polygonTokens.usdt,
  },
  {
    pid: 3,
    lpSymbol: 'CANDY-USDC LP',
    lpAddress: '0x26fEa198cE848499Bba6eeb0a4b97561009E96A0',
    boosted: true,
    token: polygonTokens.candy,
    quoteToken: polygonTokens.usdc,
  },
  
  // {
  //   pid: 39,
  //   lpSymbol: 'CANDY',
  //   lpAddress: '0x06C04B0AD236e7Ca3B3189b1d049FE80109C7977',
  //   token: cronosTokens.candy,
  //   quoteToken: cronosTokens.usdc,
  //   isStaking: true,
  //   boosted: true
  // },
  // {
  //   pid: 5,
  //   lpSymbol: 'WCRO',
  //   lpAddress: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
  //   token: cronosTokens.wcro,
  //   quoteToken: cronosTokens.usdc,
  //   isStaking: true,
  //   boosted: true
  // },
].map((p) => ({ ...p, token: serializeToken(p.token), quoteToken: serializeToken(p.quoteToken) }))

export default farms
